import styled from "styled-components";

export const Container = styled.section`
    width: 100%;    
    height: 100vh;  
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    color: #58626c;
    padding: 0 6rem;

    @media (max-width: 870px) {
        padding: 0 3rem;
    }

    @media (max-width: 770px) {
        padding: 0 1rem;
    }
    
    h1 {
        font-family: 'Great Vibes', sans-serif;
        font-size: 4rem;
        font-weight: 200;
    }
    

    h2 {
        max-width: 500px;
        margin: 1.5rem 0;
        font-family: 'Josefin Slab', sans-serif;
        font-weight: 200;
        font-size: 2rem;
    }

    @media (max-width: 500px) {
        h1 {
            font-size: 3rem;
        }
        h2 {
            font-size: 1.7rem;
        }
    }

    div.image-gallery {
        width: 74%;
    }

    div.map-marker {
        margin-top: -35px;
        font-size: 1.2rem !important;
        font-family: 'Great Vibes', sans-serif !important;
        font-weight: 600;
        /* color: #fff !important; */
    }

`